import { useCallback, useState } from "react";
import { useAppModals } from "../../../../app/state/modalSlice/hook/use-app-modals";
import { useAppSelector } from "../../../../services/redux/hooks/use-selector";
import { selectProfile } from "../redux/selectors";
import { TProfileData } from "../types";
import { useAppDispatch } from "../../../../services/redux/hooks/use-dispatch";
import { setProfile } from "../redux/slice";

export const useProfileModal = () => {
  const dispatch = useAppDispatch();
  const { handleCloseModal } = useAppModals();
  const profile = useAppSelector(selectProfile);

  const [form, setForm] = useState<TProfileData>(() => profile);

  const canSave =
    form.username.trim() !== "" && (form.usertable ?? "").trim() !== "";

  const setUserFullName = (username: string) =>
    setForm((prev) => ({ ...prev, username }));

  const setUserTable = (usertable: string | null) =>
    setForm((prev) => ({ ...prev, usertable }));

  const save = useCallback(() => {
    if (!canSave) return;
    dispatch(
      setProfile({
        username: form.username.trim(),
        usertable: form.usertable,
        skip: false,
      }),
    );
    handleCloseModal("profile_modal");
  }, [form, canSave, dispatch, handleCloseModal]);

  const skipIdent = useCallback(() => {
    dispatch(setProfile({ skip: true }));
    handleCloseModal("profile_modal");
  }, [dispatch, handleCloseModal]);

  return {
    userFullName: form.username,
    userTable: form.usertable,
    canSave,
    setUserFullName,
    setUserTable,
    save,
    skipIdent,
  };
};
